import { useMutation } from "@tanstack/react-query";
import { updateProjectAssetDetails } from "../api/updates-project-asset-details";
export const useUpdateProjectAssetDetails = (projectId, queryParams) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (projectAssetsUpdateRequest) => {
            return updateProjectAssetDetails(projectId, queryParams, projectAssetsUpdateRequest);
        },
        retry: false
    });
};
